import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";
import { PrivateBeta } from "./PrivateBeta";

const EXEMPT_PREFIXES = ["/login", "/dashboard", "/beta-access"];

// FAIL OPEN (owner principle, Sept 2026): the holding page renders ONLY when the API explicitly says
// enabled && !unlocked. Any error, timeout, cold start or non-200 resolves to OPEN — an unreachable API means
// checkout is down anyway, so a holding page helps nobody and costs the customer.
export const BetaGate = ({ children }) => {
  const location = useLocation();
  const [locked, setLocked] = useState(false);

  useEffect(() => {
    api.get("/beta/status", { timeout: 4000 })
      .then((res) => setLocked(res?.data?.enabled === true && res?.data?.unlocked === false))
      .catch(() => setLocked(false));
  }, []);

  const exempt =
    EXEMPT_PREFIXES.some((p) => location.pathname === p || location.pathname.startsWith(p + "/")) ||
    location.hash?.includes("session_id=");

  if (exempt || !locked) return children;
  return <PrivateBeta />;
};
